import { Button, Link } from '@mui/material';
import { styled } from '@mui/material/styles';

export const LoyaltyButton = styled(Button)(({ theme }) => ({
  borderRadius: 24,
  fontSize: 18,
  fontWeight: 500,
  '@media (max-width: 600px)': {
    fontSize: 14,
  },
  '&.MuiButton-contained': {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[500],
      color: theme.palette.common.white,
    },
  },
  '&.MuiButton-outlined': {
    '&.Mui-disabled': {
      borderColor: theme.palette.grey[500],
      color: theme.palette.grey[500],
      backgroundColor: theme.palette.common.white,
    },
  },
}));

export const StyledLink = styled(Link)(() => ({
  textDecoration: 'none',
}));
